module.exports = __webpack_public_path__ + "img/LCATree3_Side.3b31e031.png";